import { render, staticRenderFns } from "./FluxFondosStep2.vue?vue&type=template&id=9aa9e91a"
import script from "./FluxFondosStep2.vue?vue&type=script&lang=js"
export * from "./FluxFondosStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports